module.exports = __tmimport("~endpoint:{controller: \'customized/api\', action: \'retry_payment\'}");